(() => {
  const initQuantity = (root = document) => {
    root.querySelectorAll('.rv-native-form').forEach((form) => {
      if (form.dataset.quantityReady === 'true') return;
      form.dataset.quantityReady = 'true';
      const input = form.querySelector('input[name="quantity"]');
      if (!input || input.type === 'hidden') return;
      const change = (direction) => {
        const min = Number(input.min) || 1;
        const max = input.max ? Number(input.max) : Infinity;
        const step = Number(input.step) || 1;
        const current = Number(input.value) || min;
        input.value = String(Math.min(max, Math.max(min, current + direction * step)));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      };
      form.querySelector('[data-rv-quantity-minus]')?.addEventListener('click', () => change(-1));
      form.querySelector('[data-rv-quantity-plus]')?.addEventListener('click', () => change(1));
    });
  };
  const initTabs = (root = document) => {
    root.querySelectorAll('[data-rv-tabs]').forEach((tabs) => {
      if (tabs.dataset.tabsReady === 'true') return;
      tabs.dataset.tabsReady = 'true';
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const panels = [...tabs.querySelectorAll('[role="tabpanel"]')];
      tabs.querySelector('.rv-tabs')?.classList.add('is-enhanced');
      const select = (button, focus = false) => {
        buttons.forEach((item) => {
          const selected = item === button;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.id !== button.getAttribute('aria-controls'); });
        if (focus) button.focus();
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          select(buttons[next], true);
        });
      });
      if (buttons[0]) select(buttons[0]);
    });
  };
  const initCompare = (root = document) => {
    root.querySelectorAll('[data-rv-compare]').forEach((compare) => {
      if (compare.dataset.compareReady === 'true') return;
      compare.dataset.compareReady = 'true';
      const input = compare.querySelector('input[type="range"]');
      if (!input) return;
      const update = () => {
        compare.style.setProperty('--position', `${input.value}%`);
        input.setAttribute('aria-valuetext', `${input.value}% after image revealed`);
      };
      input.addEventListener('input', update);
      update();
    });
  };
  const init = (root = document) => { initQuantity(root); initTabs(root); initCompare(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
